module.exports = __webpack_public_path__ + "static/img/payment.4acb5608.svg";